export const BiomeNames = ['Forest', 'Spring', 'Desert', 'Winter', 'Tropical'];

export const MentorNames = [
  'Guardian Greenleaf',
  'Guardian Springtide',
  'Guardian Dune',
  'Guardian Avalanche',
  'Guardian Calypso',
];

export const MentorPrefixes = [
  'greenleaf',
  'springtide',
  'dune',
  'avalanche',
  'monsoon',
];

export const BiomeImages = [
  'duel-arena-forest',
  'duel-arena-spring',
  'duel-arena-desert',
  'duel-arena-winter',
  'duel-arena-tropical',
];

interface CodeBankExample {
  phoneme: string;
  word: string;
  position: string;
  humanFriendly: string;
  description?: string;
  codeId: number;
}

interface CodeBankPhoneme {
  spelling: string;
  examples: CodeBankExample[];
}

export interface CodeBank {
  phonemes: CodeBankPhoneme[];
}

interface Concept {
  explanation: string;
  script?: string[];
}

export interface Concepts {
  [key: string]: Concept;
}
export interface ScriptItem {
  id: string;
  script: string[];
}

export interface ScriptGrapheme extends ScriptItem {
  relatedConcepts: string[];
}

export interface ScriptMorpheme extends ScriptGrapheme {
  morpheme: string;
}

export interface DialogueSlide {
  graphemeData?: ScriptGrapheme;
  morphemeData?: ScriptMorpheme;
  script: string;
  chunkIndex: number;
}
